export default __webpack_public_path__ + "static/media/model.e2fc21aa.svg";